import React from 'react';

const ColorField = ({ label, value, onChange }) => {
  const color = value || '#4f6ef7';

  return (
    <div className="admin-color-field">
      <span className="admin-color-label">{label}</span>
      <div className="admin-color-inputs">
        <input
          type="color"
          value={color}
          onChange={(e) => onChange(e.target.value)}
          className="admin-color-picker"
        />
        <input
          type="text"
          value={color}
          onChange={(e) => onChange(e.target.value)}
          className="admin-color-hex"
          maxLength={7}
        />
      </div>
    </div>
  );
};

export default ColorField;
